import React, { memo } from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../Sidebar/Layout.js";

const WithNav = memo(() => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
});

WithNav.displayName = 'WithNav';
export default WithNav;
